@if (employmentConditions(); as employmentConditions) {
  <div class="contract-cell {{ cellColor() }}">
    <ng-container
      *ngTemplateOutlet="contractTemplate; context: { employmentConditions }"
    ></ng-container>
  </div>

  <div class="hidden">
    <ng-container
      *ngTemplateOutlet="contractTemplate; context: { employmentConditions }"
    ></ng-container>
  </div>
} @else {
  -
}

<ng-template let-employmentConditions="employmentConditions" #contractTemplate>
  <div class="contract-container">
    @if (employmentConditions.contractTerm?.indefinite) {
      <p>{{ 'labels.indefiniteTime' | translate }}</p>
    } @else {
      <app-date-range-cell
        [range]="employmentConditions.contractTerm"
      ></app-date-range-cell>
    }

    <div class="information f-body-s f-muted">
      <p>
        {{
          `${DictionaryCode.CONTRACT_TYPE}.${employmentConditions.contractType}`
            | translate
        }}
      </p>

      <p>·</p>

      @switch (employmentConditions.settlementMethod) {
        @case (DriverSettlementMethod.DAILY_RATE) {
          <p class="daily-rate">
            {{ employmentConditions.dailyRate | onyxAmount: 'value' : false }}

            <span>/{{ 'labels.daily' | translate | lowercase }}</span>
          </p>
        }
        @case (DriverSettlementMethod.MILEAGE_RATE) {
          <p class="milage-rate">
            {{ employmentConditions.mileageRate | onyxAmount: 'value' : false }}

            <span>/km</span>
          </p>
        }
        @case (DriverSettlementMethod.BASE_PLUS_PERCENTAGE) {
          <p>
            {{ employmentConditions.baseRate | onyxAmount: 'value' : false }}

            <span>
              + {{ employmentConditions.freightPercentage
              }}{{ 'labels.freightPercentage' | translate }}
            </span>
          </p>
        }
        @case (DriverSettlementMethod.ROUND_TRIP_RATE) {
          <p class="round-trip">
            {{
              employmentConditions.roundTripRate | onyxAmount: 'value' : false
            }}

            <span>/{{ 'labels.circle' | translate }}</span>
          </p>
        }
      }
    </div>
  </div>
</ng-template>
